export default __webpack_public_path__ + "static/media/image-main-3-m@2x.9f117730.webp";